export const GroupTypes = {
  SERIES: "s",
  MAP: "m",
};

export const ValueType = {
  VALUE: "v",
  INDE: "id",
  INDERATE: "idr",
};

export const InDeType = {
  WEEKLY: "W",
  MONTHLY: "M",
  YEARLY: "Y",
  AVERAGE: "A",
};

const v = [ValueType.VALUE];
const vr = [ValueType.VALUE, ValueType.INDERATE];

const inde = (
  min,
  max,
  minInde,
  maxInde,
  minRate,
  maxRate,
  reversed = false,
  supported = [ValueType.VALUE, ValueType.INDE, ValueType.INDERATE]
) => {
  return {
    min,
    max,
    minInde,
    maxInde,
    minRate,
    maxRate,
    reversed,
    supported,
  };
};

export const DataNames = {
  PRICE_INDEX: "PI",
  PRICE_INDEX_CHANGED_RATE: "PICR",
  DEAL_LEASE_GAP: "DLG",
  LEASE_RATIO_FOR_DEAL: "RFD",
  PRICE_PER_P: "PPP",
  AVERAGE_PRICE: "AVP",
  AVERAGE_PRICE_PER_A: "AVPPA",
  PRICE_INDEX_PER_A: "PIPA",
  ADVANTAGE_INDEX: "ADI",
  ACTIVITY_INDEX: "ACI",
  SUPPLY_INDEX: "SUI",
  PRICE_VIEW: "PV",
  MOVE_IN_COUNT: "MIC",
  PURCHASE_BURDEN: "PB",
  REAL_PRICE: "RP",
  REAL_PRICE_COMPARABLE_MEDIAN: "RPCM",
  REAL_PRICE_COUNT: "RPC",
  REAL_PRICE_HOUSEHOLD_INDEX: "RPHI",
  MAPPED_REAL_PRICE_COUNT: "MRPC",
  NEW_HIGH_DEAL_COUNT: "NHDC",
  NEW_HIGH_DEAL_HOUSEHOLD_INDEX: "NHDI",
  INCREASED_DEAL_COUNT: "IDC",
  INCREASED_DEAL_HOUSEHOLD_INDEX: "IDI",
  SALE_COUNT: "SC",
  UNSOLD_COUNT: "UC",
  MARKET_PRICE_INFO: "MPI",
  MARKET_PRICE: "MP",
  MARKET_PRICE_MAX: "MPMX",
  MARKET_PRICE_MIN: "MPMN",
  DEAL_QUINTILE_PRICE: "DQP",
  LEASE_QUINTILE_PRICE: "LQP",
  DEAL_MP_QUINTILE: "DMPQ",
  LEASE_MP_QUINTILE: "LMPQ",
  SUPPLY_COUNT: "SPC",
  CURRENCY: "CC",
  POPULATION_DATE: "PD",
  HOUSEHOLD_DATE: "HD",
};

export const InDeMap = new Map([
  [DataNames.PRICE_INDEX, inde(0, 200, -3, 3, -3, 3)],
  [DataNames.UNSOLD_COUNT, inde(0, 1000, -100, 100, -3, 3)],
  [DataNames.MOVE_IN_COUNT, inde(0, 100000, -10000, 10000, -40, 40)],
  [DataNames.SUPPLY_COUNT, inde(0, 600000, -300000, 300000, -40, 40)],
  [DataNames.REAL_PRICE_COUNT, inde(0, 20000, -5000, 5000, -40, 40)],
  [DataNames.SALE_COUNT, inde(0, 20000, -3000, 3000, -3, 3)],
  // [DataNames.UNSOLD_COUNT, inde(0, 1000, -100, 100, -3, 3, true)],
  // [DataNames.MOVE_IN_COUNT, inde(0, 100000, -10000, 10000, -40, 40, true)],
  // [DataNames.SUPPLY_COUNT, inde(0, 600000, -300000, 300000, -40, 40, true)],
  // [DataNames.REAL_PRICE_COUNT, inde(0, 20000, -5000, 5000, -40, 40)],
  // [DataNames.SALE_COUNT, inde(0, 20000, -3000, 3000, -3, 3, true)],

  [DataNames.MARKET_PRICE_INFO, inde(0, 1000000000, -6000000, 6000000, -3, 3)],
  [DataNames.MARKET_PRICE, inde(0, 1000000000, -3000000, 3000000, -3, 3)],
  [DataNames.MARKET_PRICE_MAX, inde(0, 1000000000, -3000000, 3000000, -3, 3)],
  [DataNames.MARKET_PRICE_MIN, inde(0, 1000000000, -3000000, 3000000, -3, 3)],
  [DataNames.DEAL_QUINTILE_PRICE, inde(0, 1000000000, -6000000, 6000000, -3, 3)],
  [DataNames.LEASE_QUINTILE_PRICE, inde(0, 1000000000, -6000000, 6000000, -3, 3)],
  [DataNames.DEAL_MP_QUINTILE, inde(0, 1000000000, -3000000, 3000000, -3, 3)],
  [DataNames.LEASE_MP_QUINTILE, inde(0, 1000000000, -3000000, 3000000, -3, 3)],

  [DataNames.REAL_PRICE, inde(0, 1000000000, -10000000, 10000000, -3, 3)],
  [DataNames.LEASE_RATIO_FOR_DEAL, inde(0, 90, -1, 1, -0.7, 0.7)],
  [DataNames.PRICE_PER_P, inde(0, 200000000, -200000, 200000, -10, 10)],
  [DataNames.DEAL_LEASE_GAP, inde(0, 600000000, -20000000, 20000000, -10, 10)],
  // [
  //   DataNames.DEAL_LEASE_GAP,
  //   inde(0, 600000000, -20000000, 20000000, -10, 10, true),
  // ],

  [DataNames.ADVANTAGE_INDEX, inde(0, 100, -20, 20, -20, 20)],
  [DataNames.SUPPLY_INDEX, inde(0, 120, -10, 10, -10, 10)],
  [DataNames.ACTIVITY_INDEX, inde(0, 20, -10, 10, -100, 100)],
  [DataNames.PRICE_VIEW, inde(0, 100, -5, 5, -5, 5)],
  [DataNames.PURCHASE_BURDEN, inde(0, 150, -5, 5, -5, 5)],
  // [DataNames.PURCHASE_BURDEN, inde(0, 150, -5, 5, -5, 5, true)],
  [DataNames.POPULATION_DATE, inde(0, 10000000, -100000, 100000, -1, 1)],
  [DataNames.HOUSEHOLD_DATE, inde(0, 5000000, -50000, 50000, -2, 2)],

  // 이후 여기에 계속 추가
  // [DataNames.ADVANTAGE_INDEX, inde(...)]
]);
const DEFAULT_INDE = inde(0, 200, -3, 3, -3, 3);

export const getInDeOption = (dataName) => {
  return InDeMap.get(dataName) ?? DEFAULT_INDE;
};

export const DataTypes = {
  DEAL: "D",
  LEASE: "L",
  RENT: "R",
  LEASERENT: "LR",
  TOTAL: "T",
  NORMAL: "N",
  AFTER: "A",
  PERMIT: "PM",
  START: "ST",
  END: "EN",
  SALE: "SL",
  BUYER_MANY: "BM",
  SELLER_MANY: "SM",
  ENOUGH: "EH",
  LEAK: "LK",
  DEAL_ACTIVITY: "DAC",
  DEAL_QUIET: "DQU",
  LEASE_ACTIVITY: "LAC",
  LEASE_QUIET: "LQU",
  DEAL_INCREASE: "DIN",
  DEAL_DECREASE: "DDE",
  LEASE_INCREASE: "LIN",
  LEASE_DECREASE: "LDE",
};

export const DateTypes = {
  YEARLY: "Y",
  QUARTERLY: "Q",
  MONTHLY: "M",
  WEEKLY: "W",
  DAILY: "D",
};

export const DataRanges = {
  ECONOMY: "E",
  GROUP: "SR",
  SIDO: "S",
  GUNGU: "G",
  DONG: "D",
  APT: "A",
  MINISTRY_APT: "MA",
  PYEONG: "P",
  EPYEONG: "EP",
  SPYEONG: "SP",
  MPYEONG: "MP",
};

export const DataSources = {
  KAB: "KAB",
  KBSTART: "KBS",
  NAVER: "ONN",
  MINISTRY: "MIN",
  MINSITE: "MST",
  KOSIS: "KOS",
  KBANK: "KBK",
  PYEONG: "PY",
  FINANCE_CORPORATION: "FC",
};

export const UIConfig = {
  highchartXaxisCount: 10,
  stackSpacing: { sx: 0, lg: 0 },
  mainBoxSx: {
    flexGrow: 1,
    py: 1,
    px: 1,
  },
  mobileMainBoxSx: {
    flexGrow: 1,
    py: 1,
    px: 0,
  },
};

export const DataConfig = {
  defaultFromMonth: 24,
  defaultFromWeek: 1,
};

export const ConfigNames = {
  nationalRank: "nationalRank",
  mainRegion: "mainRegion",
  sidoMainIndex: "sidoMainIndex",
  gunguMainIndex: "gunguMainIndex",
  sidoPriceIndex: "sidoPriceIndex",
  sidoMarketIndex: "sidoMarketIndex",
  sidoTimeSeries: "sidoTimeSeries",
  gunguTimeSeries: "gunguTimeSeries",
  gunguPriceIndexChangedRate: "sidoGunguPriceIndexChangedRate",
  regionFilterTest: "regionFilterTest",
  datalakeTest: "datalakeTest",
  sidoAnalyze: "sidoAnalyze",
  aptAnalyze: "aptAnalyze",
  gunguAnalyze: "gunguAnalyze",
  multiAnalyze: "multiAnalyze",
  gunguGroupFilterTest: "gunguGroupFilter",
  aptDefault: "aptDefault",
  naverMapTest: "naverMapTest",
};

export const RankType = {
  PRICE_INDEX: "pi",
  REAL_PRICE: "rp",
  SALE_COUNT: "sc",
  MARKET_PRICE: "mp",
  MOVE_IN: "mi",
  UNSOLD: "us",
};

export const PyeongType = {
  PYEONG: "P",
  EPYEONG: "EP",
  MPYEONG: "MP",
  SPYEONG: "SP",
};

export const SaleType = {
  DEAL: "deal",
  LEASE: "lease",
  RENT: "rent",
  LAR: "leaseAndRent",
  TOTAL: "total",
  NORMAL: "normal",
  AFTER: "after",
};

export const ChartType = {
  COLUMN: "column",
  LINE: "line",
  AREA: "area",
  SCATTER: "scatter",
};

export const ChartSize = {
  SMALL: "S",
  MEDIUM: "M",
  LARGE: "L",
};

export const ConfigType = {
  INDIVIDUAL: "I",
  UNION: "U",
  ALLVISIBLE: "AV",
  ENABLE: "E",
  DISABLE: "D",
  TOTAL: "T",
  GROUP: "G",
  AUTO: "A",
  MANUAL: "M",
  LEFT: "L",
  RIGHT: "R",
  INDE: "ID",
  INDERATE: "IDR",
  MOVING: "M",
};

export const DashType = {
  SOLID: "Solid",
  SOLIDDASH: "ShortDash",
  SHORTDOT: "ShortDot",
  SHORTDASHDOT: "ShortDashDot",
  SHORTDASHDOTDOT: "ShortDashDotDot",
  DOT: "Dot",
  DASH: "Dash",
  LONGDASH: "LongDash",
  DASHDOT: "DashDot",
  LONGDASHDOT: "LongDashDot",
  LONGDASHDOTDOT: "LongDashDotDot",
};

export const OrderStatusType = {
  CONFIRMED: "CONFIRMED",
  CANCELLED: "CANCELLED",
  READY: "READY",
  REFUND: "REFUND",
  FAILED: "FAILED",
};

export const LineThicknessType = {
  ONE: 2,
  TWO: 5,
  THREE: 8,
};

export const DatesRangeType = {
  COMPARE: "C",
  ACCUMULATE: "A",
  SINGLE: "S",
};

export const CompareType = {
  COMPARE: "C",
  INDIVIDUAL: "I",
};

export const MoveInAnalyzeType = {
  COMPARE_GUNGU: "CG",
  COMPARE_APT: "CA",
  COMPARE_INDEX: "CI",
};

export const AptPriceCompareType = {
  DEAL_LEASE: "DL",
  PRICE_PER_PYEONG: "PPP",
  LEASE_PRICE_RATE: "LPR",
};

export const HeaderOption = {
  BACKGROUND_COLOR: "BC",
};

export const AptDataName = {
  NORMAL_INFO: "NI",
  PRICE_COMPARE: "PC",
  APT_LEVEL: "AL",
  PRICE_ANALYZE: "PA",
};

export const TypeName = new Map([
  [DateTypes.MONTHLY, "월간"],
  [DateTypes.YEARLY, "년간"],
  [DateTypes.WEEKLY, "주간"],
]);

export const MarketData = {
  BUYER_MANY_KEY: "BM",
  SELLER_MANY_KEY: "SM",
  ENOUGH_KEY: "EN",
  BANANCE_KEY: "BN",
  LEAK_KEY: "LK",
  ACTIVITY_KEY: "AC",
  QUIET_KEY: "QU",
  INCREASE_KEY: "IC",
  LITTLE_INCREASE_KEY: "LI",
  DECREASE_KEY: "DC",
  LITTLE_DECREASE_KEY: "LD",
  SIMILAR_KEY: "SI",
  NORMAL_KEY: "NM",
};

export const PyeongData = {
  DEAL_PRICE_MIN_KEY: "DPMI",
  DEAL_PRICE_AVR_KEY: "DPAV",
  DEAL_PRICE_MAX_KEY: "DPMA",

  LEASE_PRICE_MIN_KEY: "LPMI",
  LEASE_PRICE_AVR_KEY: "LPAV",
  LEASE_PRICE_MAX_KEY: "LPMA",

  LEASE_PRICE_RATE_MIN_KEY: "LPRMI",
  LEASE_PRICE_RATE_AVR_KEY: "LPRAV",
  LEASE_PRICE_RATE_MAX_KEY: "LPRMA",

  DEAL_PRICE_PS_MIN_KEY: "DPPSMI",
  DEAL_PRICE_PS_AVR_KEY: "DPPSAV",
  DEAL_PRICE_PS_MAX_KEY: "DPPSMA",

  LEASE_PRICE_PS_MIN_KEY: "LPPSMI",
  LEASE_PRICE_PS_AVR_KEY: "LPPSAV",
  LEASE_PRICE_PS_MAX_KEY: "LPPSMA",

  DEAL_SALE_COUNT_KEY: "DSC",
  LEASE_SALE_COUNT_KEY: "LSC",
  RENT_SALE_COUNT_KEY: "RSC",

  DEAL_REAL_PRICE_KEY: "DRPC",
  LEASE_REAL_PRICE_KEY: "LRPC",
  RENT_REAL_PRICE_KEY: "RRPC",
  RENT_LEASE_REAL_PRICE_KEY: "RLRPC",

  MARKET_PRICE_DATE_KEY: "MPD",
  SALE_COUNT_DATE_KEY: "SCD",
  DEAL_RP_DATE_KEY: "DRPD",
  LEASE_RP_DATE_KEY: "DRPD",
  RENT_RP_DATE_KEY: "RRPD",
  RENT_LEASE_RP_DATE_KEY: "RLRPD",
};

export const AptDataKey = {
  PYEONG_ID: "pyeongId",
};

export const AdditionalData = {
  PROPER_MOVEIN_COUNT: "PMCK",
};

export const SortType = {
  NORMAL: "NORMAL",
  DESC: "DESC",
  ASC: "ASC",
};

export const Texts = {
  TOTAL: "전체",
  DURATION: "기간",
  PYEONG: "면적",
  INDE: "증감누적",
  COMPARE_DURATION: "비교기간",
};
